(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-blog-halloween-photo-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ag-blog-compare')) {
    customElements.define('ag-blog-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const range = this.querySelector('[data-compare-range]');
        const stage = this.querySelector('[data-compare-stage]');
        const output = this.querySelector('[data-compare-output]');
        if (!range || !stage) return;
        const update = (position) => {
          const value = Math.round(Math.max(0, Math.min(100, Number(position))));
          range.value = String(value);
          this.style.setProperty('--ag-reveal', `${value}%`);
          range.setAttribute('aria-valuetext', this.dataset.valueTemplate.replace('__PERCENT__', String(value)));
          if (output) output.value = `${value}%`;
        };
        const move = (event) => {
          const rect = stage.getBoundingClientRect();
          if (rect.width) update((event.clientX - rect.left) / rect.width * 100);
        };
        let activePointer = null;
        range.addEventListener('input', () => update(range.value));
        stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          activePointer = event.pointerId;
          stage.setPointerCapture(activePointer);
          move(event);
        });
        stage.addEventListener('pointermove', (event) => {
          if (event.pointerId === activePointer) move(event);
        });
        const finish = (event) => {
          if (event.pointerId !== activePointer) return;
          if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
          activePointer = null;
        };
        stage.addEventListener('pointerup', finish);
        stage.addEventListener('pointercancel', finish);
        this.querySelectorAll('[data-compare-position]').forEach(button => {
          button.addEventListener('click', () => update(button.dataset.comparePosition));
        });
        update(range.value);
        this.setAttribute('data-ready', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ag-blog-photo-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ag-blog-compare')) {
    customElements.define('ag-blog-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const range = this.querySelector('[data-compare-range]');
        const stage = this.querySelector('[data-compare-stage]');
        const output = this.querySelector('[data-compare-output]');
        if (!range || !stage) return;
        const update = (position) => {
          const value = Math.round(Math.max(0, Math.min(100, Number(position))));
          range.value = String(value);
          this.style.setProperty('--ag-reveal', `${value}%`);
          range.setAttribute('aria-valuetext', this.dataset.valueTemplate.replace('__PERCENT__', String(value)));
          if (output) output.value = `${value}%`;
        };
        const move = (event) => {
          const rect = stage.getBoundingClientRect();
          if (rect.width) update((event.clientX - rect.left) / rect.width * 100);
        };
        let activePointer = null;
        range.addEventListener('input', () => update(range.value));
        stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          activePointer = event.pointerId;
          stage.setPointerCapture(activePointer);
          move(event);
        });
        stage.addEventListener('pointermove', (event) => {
          if (event.pointerId === activePointer) move(event);
        });
        const finish = (event) => {
          if (event.pointerId !== activePointer) return;
          if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
          activePointer = null;
        };
        stage.addEventListener('pointerup', finish);
        stage.addEventListener('pointercancel', finish);
        this.querySelectorAll('[data-compare-position]').forEach(button => {
          button.addEventListener('click', () => update(button.dataset.comparePosition));
        });
        update(range.value);
        this.setAttribute('data-ready', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ag-trust-badge-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ag-trust-badges')) {
    class AgTrustBadges extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.list = this.querySelector('.ag-trust-badges__list');
        this.items = [...this.querySelectorAll('.ag-trust-badges__details')];
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.handleOutsidePointer = this.handleOutsidePointer.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.items.forEach((details) => {
          const trigger = details.querySelector('summary');
          details.addEventListener('toggle', () => this.handleToggle(details));
          details.addEventListener('pointerover', (event) => this.handlePointerOver(details, event));
          details.addEventListener('pointerout', (event) => this.handlePointerOut(details, event));
          details.addEventListener('focusin', (event) => {
            if (event.target.matches(':focus-visible')) this.open(details);
          });
          details.addEventListener('focusout', () => window.setTimeout(() => this.handleFocusOut(details), 0));
          trigger?.addEventListener('click', (event) => {
            if (!this.hoverQuery.matches) return;
            event.preventDefault();
            this.open(details);
          });
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const openDetails = this.querySelector('.ag-trust-badges__details[open]');
          this.closeAll();
          openDetails?.querySelector('summary')?.focus();
        });

        document.addEventListener('pointerdown', this.handleOutsidePointer);
        window.addEventListener('resize', this.handleResize, { passive: true });
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.handleOutsidePointer);
        window.removeEventListener('resize', this.handleResize);
      }

      handleToggle(details) {
        const trigger = details.querySelector('summary');
        trigger?.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          this.items.forEach((item) => {
            if (item !== details) this.close(item);
          });
          this.positionPopover(details);
        } else if (!this.querySelector('.ag-trust-badges__details[open]')) {
          this.style.setProperty('--ag-touch-open-space', '0px');
        }
      }

      handlePointerOver(details, event) {
        if (!this.hoverQuery.matches || details.contains(event.relatedTarget)) return;
        this.open(details);
      }

      handlePointerOut(details, event) {
        if (!this.hoverQuery.matches || details.contains(event.relatedTarget)) return;
        if (!details.contains(document.activeElement)) this.close(details);
      }

      handleFocusOut(details) {
        if (!details.contains(document.activeElement) && !details.matches(':hover')) this.close(details);
      }

      handleOutsidePointer(event) {
        if (!this.contains(event.target)) this.closeAll();
      }

      handleResize() {
        const openDetails = this.querySelector('.ag-trust-badges__details[open]');
        if (openDetails) this.positionPopover(openDetails);
      }

      open(details) {
        if (!details.open) details.open = true;
        this.positionPopover(details);
      }

      close(details) {
        if (!details.open) return;
        details.open = false;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }

      closeAll() {
        this.items.forEach((details) => this.close(details));
        this.style.setProperty('--ag-touch-open-space', '0px');
      }

      positionPopover(details) {
        const trigger = details.querySelector('summary');
        const popover = details.querySelector('.ag-trust-badges__popover');
        if (!this.list || !trigger || !popover || !details.open) return;

        window.requestAnimationFrame(() => {
          const listRect = this.list.getBoundingClientRect();
          const triggerRect = trigger.getBoundingClientRect();
          const maxWidth = Math.max(0, listRect.width - 8);
          const popoverWidth = Math.min(292, maxWidth);
          const preferredCenter = triggerRect.left + (triggerRect.width / 2) - listRect.left;
          const minimumCenter = (popoverWidth / 2) + 4;
          const maximumCenter = listRect.width - (popoverWidth / 2) - 4;
          const clampedCenter = Math.max(minimumCenter, Math.min(maximumCenter, preferredCenter));
          popover.style.setProperty('--ag-popover-left', `${clampedCenter}px`);

          if (this.hoverQuery.matches) {
            this.style.setProperty('--ag-touch-open-space', '0px');
          } else {
            this.style.setProperty('--ag-touch-open-space', `${popover.offsetHeight + 12}px`);
          }
        });
      }
    }

    customElements.define('ag-trust-badges', AgTrustBadges);
  }
  } catch(e) { console.error(e); }
})();

})();
